import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  top: 25px;
  right: 25px;
  max-width: 320px;
  min-width: 320px;
`;
